// @ts-nocheck
export const fieldList = (context: string) => [
	[
		{
			auxEntity: {
				entityUrl: '/task/drop-data',
				tableName: 'justify',
			},
			size: 40,
			entityKey: 'justify',
			disabled: false,
			label: 'Justificativa',
			type: 'SELECT_ONE',
			required: false,
			forceFieldDisplay: true, // Isso não deveria estar aqui, é crime em 72 países diferentes
		},
	],
	[
		{
			size: 100,
			entityKey: 'observation',
			disabled: false,
			label: 'Observação',
			type: 'TEXTAREA',
			forceFieldDisplay: true, // Isso não deveria estar aqui, é crime em 72 países diferentes
		},
	],
	[
		{
			disabled: false,
			auxEntity: {
				entityRecoverUrl: '/audience/getHistoricFileById',
				entityParameters: [
					{
						parameterKey: 'documentType',
						formKey: 'documentType',
						extractFromAllValues: true,
					},
				],
			},
			context,
			loadProcessId: true,
			helperText: '',
			configuration: {
				primary: [
					{
						disabled: false,
						entityKey: 'divergence',
						label: 'Divergente',
						size: 50,
						type: 'TEXT',
					},
					{
						auxEntity: {
							entityUrl: '/task/drop-data',
							tableName: 'justify',
						},
						entityKey: 'justify',
						label: 'Justificativa',
						size: 30,
						type: 'LIST_REF',
					},
					{
						entityKey: 'createdAt',
						label: 'Data de criação',
						size: 20,
						type: 'CALENDAR',
					},
				],
			},
			label: 'URLs',
			size: 100,
			type: 'TABLE_LIST',
			forceFieldDisplay: true,
		},
	],
];
